import { loadable } from '../../../utils';

export const Card = loadable(() => import('./Card'), {});
export const Options = loadable(() => import('./Options'), {});
export const Menu = loadable(() => import('./Menu'), {});
export const Settings = loadable(() => import('./Settings'), {});
export const Webhooks = loadable(() => import('./Webhooks'), {});
